<script setup>
    import { ref, onActivated, onMounted } from 'vue';

    const props = defineProps(['value', 'editor_id']);

    
    const emit = defineEmits(['update:modelValue']);
    const onInput = (e) => {
        emit('update:modelValue', e.target.value);
    }
</script>

<template>

    <!-- <ElInput type="textarea" v-model="props.content" :id="props.editor_id" :key="props.editor_id" /> -->
    <div>
        <textarea v-model="props.value" :id="props.editor_id" :key="props.editor_id" @input="onInput"></textarea>
    </div>
    
</template>